<template>
  <div class="file-cell-wrapper">
    <a-upload
      action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
      :headers="uploadHeaders"
      list-type="picture-card"
      :file-list="form.coverPhoto"
      @preview="handlePreview"
      @change="handleAttachmentChange"
      :disabled="!isEditable"
      :multiple="true"
      :show-upload-list="true"
      accept=".jpg,.png,.jpeg"
      :data="{ uploadType: 201 }"
    >
      <span v-if="!form.coverPhoto || form.coverPhoto.length === 0">
        <div v-if="isEditable">
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
        </div>
        <div v-else>--</div>
      </span>
    </a-upload>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewHandleCancel"
      width="900px"
      class="preview-image-modal"
      centered
    >
      <div class="preview-wrapper">
        <img :src="previewImage" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: undefined,
    };
  },
  methods: {
    //上传附件
    handleAttachmentChange({ fileList }) {
      const newList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          }
          if (item.response.code == "508") {
            setTimeout(() => {
              this.$notification.warning({
                message: `上传失败`,
                description: item.response.msg,
              });
            }, 500);
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.form.coverPhoto = newList;
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },
  },
};
</script>

<style  scoped>
.file-cell-wrapper /deep/ .ant-upload-list-item-name {
  position: relative;
  top: 3px;
  display: inline-block;
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>